import React, {useEffect} from 'react'
import {useMutation} from '@apollo/client'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import {COMPLETE_POLICY} from '../../../gql/mutations/policyMutation'
import {IResCompletePolicy} from '../soldTypes'

interface IModalProps {
  id: string
  isOpen: boolean
  onClose: () => void
  refetch: () => void
}
export const ModalCompletePolicy: React.FC<IModalProps> = ({isOpen, onClose, id, refetch}) => {
  const [gqlCancel, {data, loading, error}] = useMutation<IResCompletePolicy>(COMPLETE_POLICY)

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  useEffect(() => {
    if (!data) return

    if (data && data.completePolicy.success) {
      toast.success('Policy cancelled successfully')
      refetch()
      onClose()
    } else if (data.completePolicy.errors && data.completePolicy.errors.length > 0) {
      toast.error(`Error ${data.completePolicy.errors[0].message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlCancel({
      variables: {
        id: parseId(id),
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Complete policy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className='fs-2'>Are you sure you want to mark this policy as completed?</h4>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button variant='success' onClick={handleDelete} disabled={loading}>
          {loading && <Spinner animation='border' size='sm' className='me-2' />}
          Complete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
